import React, { useState } from 'react';
import { TableBody as MuiTableBody, TableRow, TablePagination } from '@mui/material';

export const PAGE_SIZES = [10, 25, 50];

// Drop-in for MUI's TableBody: when it holds more than 10 rows it shows them a page at a time
// with a "Rows per page · 1–10 of 45 · ‹ ›" bar as its last row. Each top-level child (one
// mapped row, or a fragment of rows for one record) counts as one row. The page is kept in
// range when filtering shrinks the list.
// A row marked data-pinned (e.g. a totals row) is not paged: it always shows after the page.
export default function TableBody({ children, pageSize = PAGE_SIZES[0], ...rest }) {
  const all = React.Children.toArray(children);
  const pinned = all.filter(r => r.props?.['data-pinned']);
  const rows = all.filter(r => !r.props?.['data-pinned']);
  const [page, setPage] = useState(0);
  const [perPage, setPerPage] = useState(pageSize);
  if (rows.length <= pageSize) return <MuiTableBody {...rest}>{children}</MuiTableBody>;

  const lastPage = Math.max(0, Math.ceil(rows.length / perPage) - 1);
  const current = Math.min(page, lastPage);
  return (
    <MuiTableBody {...rest}>
      {rows.slice(current * perPage, current * perPage + perPage)}
      {pinned}
      <TableRow>
        <TablePagination
          colSpan={100}
          count={rows.length}
          page={current}
          rowsPerPage={perPage}
          rowsPerPageOptions={PAGE_SIZES}
          onPageChange={(_, p) => setPage(p)}
          onRowsPerPageChange={e => { setPerPage(Number(e.target.value)); setPage(0); }}
          sx={{ borderBottom: 0 }}
        />
      </TableRow>
    </MuiTableBody>
  );
}
